import { AppState } from 'src/store'

export const GetLastPinged = (state: AppState) => {
    return state.ext_app.application.lastPinged
}

export const GetApplicationState = (state: AppState) => {
    return state.ext_app.application
}

export const GetInterrupt = (state: AppState) => {
    return state.ext_app.application.interrupt
}
